<template>
  <base-modal
    id="collateral-upload-modal"
    :show="value"
    title="Add Images"
    size="modal-lg"
    @closed="onClosed"
  >
    <div class="draggable-area d-flex justify-content-center align-items-center" :style="`${ items.length > 0 && toUpload.length ? '':'background: #FAF9F7;'}`">
      <input
        ref="upload"
        type="file"
        class="draggable-input"
        accept="image/png, image/jpeg, video/mp4"
        multiple
        :disabled="uploading"
        @dragover.prevent="dragover"
        @change="readFiles"
        @drop.prevent="drop"
        @dragend="dragend"
        @dragexit="dragend"
        @dragleave="dragend"
        @dragenter.prevent="dragenter"
      >
      <div
        v-if="items.length === 0"
        class="drag-square d-flex text-truncate align-items-center justify-content-center"
        @click="onClick"
      >
        <div class="text-center">
          <base-icon
            :icon="`${dragging ? 'save-pdf' : 'image'}`"
            style="width: 100px;"
            class="mb-1"
          />
          <div
            v-if="dragging"
            style="font-size: 16px; font-family: 'SilkaLight';"
          >
            Drop
          </div>
          <div
            v-else
            style="
              font-size: 16px;
              font-family: 'SilkaLight';
              margin-top: 13px;"
          >
            Drag and drop or <u style="color: #0060DF">browse</u> to choose a file
          </div>
        </div>
      </div>
      <div
        v-else
        class="d-flex thumbs-area d-flex flex-wrap"
      >
        <div
          v-for="(item, index) in items"
          :key="`collateral_upload_${index}`"
          class="m-1 thumb-wrap clickable"
          style="margin-right: 19px !important; border: none;"
          @click="onSelectItem(index)"
        >
          <base-thumbnail
            :src="item.src"
            cover
            style="width: 195px;height: 180px;"
            :class="`${!item.selected ? 'transparent' : ''}`"
          />
          <base-loading
            :show="!item.src || item.src.length === 0"
            label=""
            class="loading-thumb"
          />
          <base-icon
            :class="`selected-icon ${item.selected ? 'show' : ''}`"
            icon="selected"
          />
        </div>
        <!-- <div class="my-1 thumb-wrap clickable position-relative text-center"> -->
        <!-- <base-thumbnail
            small
            src=""
            class="border-0"
          /> -->
        <!-- <div
            class="position-absolute mr-auto ml-auto"
            style="top: 50%; transform: translateY(-50%)"
            @click="onClick"
          >
            <base-icon
              icon="plus"
              class="m-0"
            />
            <div class="m-0">
              Add Images
            </div>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="actions d-flex align-items-center justify-content-end">
      <!-- <template v-if="items.length > 0 && toUpload.length > 0"> -->
      <template>
        <base-button
          :disabled="uploading"
          class="justify-content-end"
          style="width: 74px; padding: 0px 13px"
          @click="onClosed"
        >
          Cancel
        </base-button>
      </template>
      <!-- <template v-else>
        <base-button
          style="color:#333;"
          :disabled="uploading"
          @click="onClick"
        >
          Add Images
        </base-button>
      </template> -->
      <base-button
        inverse
        :disabled="toUpload.length === 0 || uploading"
        @click="onUpload"
      >
        <span v-if="!uploading">Upload {{ toUpload.length ? toUpload.length : '' }}
          file{{ toUpload.length === 1 ? '' : 's' }}</span>
        <span
          v-else
          class="d-flex justify-content-end align-items-center"
        >
          <base-loading
            label=""
            :show="true"
            inverted
          />
          <base-text
            class="ml-2"
            nowrap
          > Uploading {{ count+1 }} of {{ toUpload.length }}</base-text></span>
      </base-button>
    </div>
  </base-modal>
</template>
<script>
export default {
  name: 'UploadCollateralModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    uploading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      items: [],
      dragging: false,
      preventFn: null,
    };
  },
  computed: {
    toUpload() {
      return this.items.filter((item) => item.selected);
    },
  },
  watch: {
    value(newval) {
      this.show = newval;
    },
    show(newval) {
      if (!newval) {
        this.$emit('input', false);
      }
    },
    count(newVal) {
      if (newVal === this.items.length) this.items = [];
    },
  },
  mounted() {
    this.preventFn = (e) => {
      e.preventDefault();
    };
    window.addEventListener('drop', this.preventFn);
    window.addEventListener('dragover', this.preventFn);
  },
  beforeDestroy() {
    window.removeEventListener('drop', this.preventFn);
    window.removeEventListener('dragover', this.preventFn);
  },
  methods: {
    onClick() {
      if (this.uploading) return;
      this.$refs.upload.click();
    },
    readFiles({ target: { files } }) {
      // append selected files
      const nItems = this.items.length;
      this.items = this.items.concat([...Array(files.length).keys()].map((index) => ({
        src: '',
        selected: false,
        file: null,
      })));
      const vm = this;

      // eslint-disable-next-line
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line
        reader.onload = function (event) {
          vm.items.splice(i + nItems, 1, { src: event.target.result, selected: true, file: files[i] });
        };

        reader.readAsDataURL(files[i]);
      }
    },
    onClosed() {
      if (this.uploading) return;
      this.items = [];
      this.show = false;
    },
    onUpload() {
      this.$mixpanel.track('upload_image', {
        account_id: this.$store.state.account.user.user.email,
        album: this.$route.params.folderId,
      });
      this.$emit('upload', this.toUpload.map((item) => item.file));
    },
    dragend() {
      this.dragging = false;
    },
    dragenter() {
      if (this.uploading) return;
      this.dragging = true;
    },
    drop(e) {
      this.dragend();
      this.readFiles({ target: { files: e.dataTransfer.files } });
    },
    dragover() {
    },
    onSelectItem(index) {
      if (this.uploading) return;
      this.items[index].selected = !this.items[index].selected;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .modal-body {
  padding: 24px 32px 24px 32px;
}

.draggable-area {
  position: relative;
  min-height: 450px;
  overflow: auto;
  margin: auto;
  max-width: 100%;
  margin-bottom: 24px;
  // background: #FAF9F7;
}

.draggable-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  cursor: pointer;
}

.drag-square {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-left: auto;
  margin-right: auto;

  width: 50%;
  height: 100%;
  // border: dashed 1px $black;
  z-index: 9;

  font-size: 13px;

  .base-icon {
    width: 27px;
    height: 27px;
  }
}
.actions{
  ::v-deep .base-button{
    min-height: 36px;
  }
}

.thumbs-area {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 11;
}

.thumb-wrap {
  position: relative;
  border: solid 1px rgba($black, 0.25);
  > div {
    transition: opacity .3s ease;
    &.transparent {
      opacity: 0.4;
    }
  }
}

.loading-thumb {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.clickable {
  cursor: pointer;
}

.selected-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  opacity: 0;
  transition: opacity .2s ease;

  &.show {
    opacity: 1;
  }
}
.drag-square {
  ::v-deep .base-icon{
    width: 35px;
    height: 50.57px;
  }
}
::v-deep .thumbnail--image{
  height: 180px;
  width: 195px;
  border-radius: 4px !important;
}
</style>
